import * as React from 'react';
import Box from '@mui/material/Box';
import { styled, ThemeProvider, createTheme } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Home from '@mui/icons-material/Home';
import People from '@mui/icons-material/People';
import CategoryIcon from '@mui/icons-material/Category';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import HistoryIcon from '@mui/icons-material/History';

const adminPanelMenus = [
	{ icon: <Home />, label: 'Dashboard', path: '/dashboard' },
	{ icon: <CategoryIcon />, label: 'Categories', path: '/categories' },
	{ icon: <CategoryIcon />, label: 'Sub Categories', path: '/sub-categories' },
	{ icon: <AddShoppingCartIcon />, label: 'Products', path: '/products' },
	{ icon: <People />, label: 'Sellers', path: '/sellers' },
	{ icon: <People />, label: 'Customers', path: '/customers' },
	{ icon: <HistoryIcon />, label: 'Orders', path: '/orders' }
];

const FireNav = styled(List)<{ component?: React.ElementType }>({
	'& .MuiListItemButton-root': {
		paddingLeft: 24,
		paddingRight: 24,
	},
	'& .MuiListItemIcon-root': {
		minWidth: 0,
		marginRight: 16,
	},
	'& .MuiSvgIcon-root': {
		fontSize: 20,
	},
});

interface LeftMenusType {
	selectedListItem: string;
	setSelectedListItemHandler: (path: string) => void;
}

const LeftMenus = (props: LeftMenusType) => {
	const { selectedListItem, setSelectedListItemHandler } = props;
	return (
		<Box sx={{ display: 'flex', height: '100%' }}>
			<ThemeProvider
				theme={createTheme({
					components: {
						MuiListItemButton: {
							defaultProps: {
								disableTouchRipple: true,
							},
						},
					},
					palette: {
						mode: 'dark',
						primary: { main: 'rgb(102, 157, 246)' },
						background: { paper: '#1976d2' }
					},
				})}
			>
				<Paper elevation={0} sx={{ width: '100%' }}>
					<FireNav component="nav" disablePadding>
						<Box>
							{adminPanelMenus.map((item) => {
								const path = item.path
								return (
									<ListItemButton
										key={item.label}
										sx={{
											py: 0, height: 48,
											color: selectedListItem === path ? 'green' : 'rgba(255,255,255,.8)',
											backgroundColor: selectedListItem === path ? 'white' : 'inherit',
											border: selectedListItem === path ? '2px solid #1976d2' : 'inherit'
										}}
										onClick={() => setSelectedListItemHandler(item.path)}
									>
										<ListItemIcon sx={{ color: 'inherit' }}>
											{item.icon}
										</ListItemIcon>
										<ListItemText
											primary={item.label}
											primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}
										/>
									</ListItemButton>
								)
							})}
						</Box>
					</FireNav>
				</Paper>
			</ThemeProvider>
		</Box>
	);
}

export default LeftMenus;

